/**
 * Contact Form — AJAX submit + reCAPTCHA v3.
 */
document.addEventListener('DOMContentLoaded', function () {
    const form = document.getElementById('contact-form');
    if (!form) return;

    const siteKey    = form.dataset.recaptchaSiteKey || '';
    const submitBtn  = form.querySelector('.btn-enviar');
    const responseEl = document.getElementById('form-response');

    function showMessage(text, type) {
        responseEl.textContent = text;
        responseEl.className   = 'form-response ' + type;
        responseEl.style.display = 'block';
        if (type === 'success') {
            setTimeout(() => { responseEl.style.display = 'none'; }, 6000);
        }
    }

    function setLoading(loading) {
        submitBtn.disabled    = loading;
        submitBtn.textContent = loading ? 'ENVIANDO…' : 'ENVIAR';
    }

    form.addEventListener('submit', async function (e) {
        e.preventDefault();
        responseEl.className = 'form-response';
        responseEl.style.display = 'none';
        setLoading(true);

        try {
            // reCAPTCHA v3: obtener token antes de enviar
            let recaptchaToken = '';
            if (siteKey && typeof grecaptcha !== 'undefined') {
                await new Promise(resolve => grecaptcha.ready(resolve));
                recaptchaToken = await grecaptcha.execute(siteKey, { action: 'contact' });
            }

            const formData = new FormData(form);
            formData.append('recaptcha_token', recaptchaToken);

            const res  = await fetch(parakeet_ajax.ajax_url, { method: 'POST', body: formData });
            const json = await res.json();

            if (json.success) {
                showMessage(json.data, 'success');
                form.reset();
            } else {
                showMessage(json.data || 'Ocurrió un error. Intentá de nuevo.', 'error');
            }
        } catch (err) {
            console.error('Contact form error:', err);
            showMessage('Error de conexión. Verificá tu internet e intentá de nuevo.', 'error');
        } finally {
            setLoading(false);
        }
    });
});
